"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildAxiosInstance = void 0;
const axios_1 = __importDefault(require("axios"));
function buildAxiosInstance(accessToken) {
    let settings = {
        baseURL: process.env.REACT_APP_API_URL,
        headers: { Authorization: accessToken || "" },
    };
    if (accessToken) {
        settings = {
            ...settings,
            headers: { Authorization: `Bearer ${accessToken}` },
        };
    }
    const axiosInstance = axios_1.default.create(settings);
    return axiosInstance;
}
exports.buildAxiosInstance = buildAxiosInstance;
